import { render, staticRenderFns } from "./EmotionDetail.vue?vue&type=template&id=8ed2bd86&scoped=true&"
import script from "./EmotionDetail.vue?vue&type=script&lang=js&"
export * from "./EmotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmotionDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./EmotionDetail.vue?vue&type=style&index=1&id=8ed2bd86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed2bd86",
  null
  
)

export default component.exports